import { render, staticRenderFns } from "./productShare.vue?vue&type=template&id=1dba1a18&scoped=true&"
import script from "./productShare.vue?vue&type=script&lang=js&"
export * from "./productShare.vue?vue&type=script&lang=js&"
import style0 from "./productShare.vue?vue&type=style&index=0&id=1dba1a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dba1a18",
  null
  
)

export default component.exports